<div *ngIf="isComponentVisible" class="d-flex flex-column h-100">
  <app-loading></app-loading>
  </div>
  <div *ngIf="!isComponentVisible" class="d-flex flex-column h-100">
    <app-nav-bar (dataEmitter)="receiveData($event)"></app-nav-bar>
    
    <div class="container flex-grow-1 flex-shrink-1">
      <router-outlet></router-outlet>
    </div>
    
    <app-footer></app-footer>
  </div>
